export enum TableFilterType {
  Equals = 'equals',
  Contains = 'contains',
  GreaterThan = 'gt',
  LessThan = 'lt',
  In = 'in',
  Custom = 'custom',
}
